/**
 * Lets non-React code (the streaming controller) navigate with the router.
 * A bridge component inside <BrowserRouter> registers the navigate function.
 */
type Navigate = (to: string, options?: { replace?: boolean }) => void

let navigateFn: Navigate | null = null

export function registerNavigator(fn: Navigate | null): void {
  navigateFn = fn
}

export function navigateTo(to: string, options?: { replace?: boolean }): void {
  if (navigateFn) navigateFn(to, options)
  else window.location.assign(to)
}

export function currentPath(): string {
  return window.location.pathname
}
